import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslations from './locales/en.json'
import arTranslations from './locales/ar.json'

export const supportedLanguages = ['en', 'ar'] as const
export type SupportedLanguage = (typeof supportedLanguages)[number]

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  ar: 'العربية',
}

export const rtlLanguages: SupportedLanguage[] = ['ar']

export function isRTL(language: string): boolean {
  return rtlLanguages.includes(language as SupportedLanguage)
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      ar: { translation: arTranslations },
    },
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  })

// Update document direction when language changes
i18n.on('languageChanged', (lng) => {
  const direction = isRTL(lng) ? 'rtl' : 'ltr'
  document.documentElement.dir = direction
  document.documentElement.lang = lng

  if (isRTL(lng)) {
    document.body.classList.add('rtl')
  } else {
    document.body.classList.remove('rtl')
  }
})

// Set initial direction
const currentLang = i18n.language || 'en'
document.documentElement.dir = isRTL(currentLang) ? 'rtl' : 'ltr'
document.documentElement.lang = currentLang

export default i18n
